import React from 'react';

function FilledTickIcon({ ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            {...props}
        >
            <path
                d="M14 3.5C8.21053 3.5 3.5 8.21053 3.5 14C3.5 19.7895 8.21053 24.5 14 24.5C19.7895 24.5 24.5 19.7895 24.5 14C24.5 8.21053 19.7895 3.5 14 3.5ZM19.8684 11.2368L13.1579 17.8947C12.7632 18.2895 12.1316 18.3158 11.7105 17.9211L8.1579 14.6842C7.73684 14.2895 7.71053 13.6316 8.07895 13.2105C8.47368 12.7895 9.13158 12.7632 9.55263 13.1579L12.3684 15.7368L18.3684 9.73684C18.7895 9.31579 19.4474 9.31579 19.8684 9.73684C20.2895 10.1579 20.2895 10.8158 19.8684 11.2368Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default FilledTickIcon;
